import React, {useEffect, useState} from "react";
import {useTheme} from "./ThemeContext";
import axios from "axios";
import {Autocomplete} from "@mui/material";
import {StyledTextField} from "../utils/Utils";

export const CommunitySearch = ({communityName, setCommunityName}) => {
    const [query, setQuery] = useState("");
    const [results, setResults] = useState([]);
    const [selectedCommunity, setSelectedCommunity] = useState(null);
    const {theme} = useTheme();

    useEffect(() => {
        if (query.length > 0) {
            const fetchData = async () => {
                try {
                    const response = await axios.get(
                        `${process.env.REACT_APP_SC_API_BASE_URL}/api/community/search?query=${query}`
                    );
                    setResults(response.data);
                } catch (err) {
                    console.error("Error fetching data:", err);
                }
            };
            fetchData();
        } else {
            setResults([]);
        }
    }, [query]);

    const handleSelect = (event, value) => {
        setSelectedCommunity(value);
        if (value) {
            setCommunityName(value.name);
        }
    };

    return (
        <div>
            <Autocomplete
                options={results}
                getOptionLabel={(option) => option.name}
                onInputChange={(event, newInputValue) => setQuery(newInputValue)}
                onChange={handleSelect}
                value={selectedCommunity}
                renderInput={(params) => (
                    <StyledTextField
                        {...params}
                        label="Search for communities..."
                        variant="outlined"
                        fullWidth
                        InputLabelProps={{
                            style: {color: theme.palette.secondary.main},
                        }}
                        sx={{
                            marginTop: "1rem",
                            color: theme.palette.secondary.main,
                            "& .MuiOutlinedInput-root": {
                                "& fieldset": {
                                    borderColor: theme.palette.primary.main,
                                },
                                "&:hover fieldset": {
                                    borderColor: theme.palette.primary.main,
                                },
                                "&.Mui-focused fieldset": {
                                    borderColor: theme.palette.primary.main,
                                },
                                "&.MuiAutocomplete-root": {
                                    backgroundColor: `${theme.palette.background.default} !important`,
                                },
                            },
                            "& .MuiInputBase-input": {
                                color: theme.palette.secondary.main,
                                backgroundColor: `${theme.palette.background.default} !important`,
                            },
                            "& input:-webkit-autofill": {
                                WebkitBoxShadow: `0 0 0 1000px ${theme.palette.background.default} inset !important`,
                                WebkitTextFillColor: `${theme.palette.secondary.main} !important`,
                            },
                        }}
                    />
                )}
            />
        </div>
    );
};